<template>
  <div class="contact_us">
    <div class="con_nav">
      <nav-tab :nav-data="navData" />
    </div>
    <div class="con_center">
      <Loan />
    </div>
    <div class="con_bottom">
      <layout-bottom />
    </div>
  </div>
</template>

<script>
import NavTab from '@/components/NavTab.vue'
import LayoutBottom from '@/components/LayoutBottom.vue'
import Loan from '@/components/loan/loanItem.vue'
export default {
  components: {
    NavTab,
    Loan,
    LayoutBottom
  },
  data() {
    return {
      navData: {
        index: 1,
        list: [
          {
            name: 'Hogar',
            link: '/'
          },
          {
            name: 'Sobre nosotros',
            link: '/sobre_nosotros'
          },
          {
            name: 'Preguntas frecuentes',
            link: '/preguntas_frecuentes'
          }
          // {
          //   name: 'Loan Introduction',
          //   link: '/faq'
          // }
          // {
          //   name: 'HOW IT WORKS',
          //   link: '/how_it_works'
          // },
          // {
          //   name: 'FAQ',
          //   link: '/faq'
          // },
          // {
          //   name: 'Loan Introduction',
          //   link: '/contact_us'
          // }
        ]
      }
    }
  }

}
</script>

<style lang="scss" scoped>
@media only screen and (min-width: 768px){
  .con_center{
    // padding-top: 60px;
  }
}
@media only screen and (max-width: 767px){}

</style>
